import template from './employee_fields.html';
import tr from '../../lib/default-translator.js';

class AdminEmployeeFieldViewModel
{
	constructor(page)
	{
		this.page = page;
	}
}

class AdminEmployeeFieldPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new AdminEmployeeFieldViewModel(this);
	}

	init()
	{
		document.title = tr('Manage Employee Fields');
		window.current_page_title(tr('Add/Edit Employee Fields'));
	}
}

export default {
	route: '[/]admin/employee_fields',
	page_class: AdminEmployeeFieldPage,
	template: template,
	template_filename: 'translation/employee_fields'
};
